export default __webpack_public_path__ + "static/media/solang valley.236c9881.jpg";